/**
 * @NOTE this change requested by the customer to have both of these items have the same height
 */
export default class LandingPage {
    constructor(element) {
        const [landingElement] = element;
        this.multiSearch = landingElement.querySelector('.articles-tabs');
        this.twitter = landingElement.querySelector('.landing-page__twitter');
        if (!this.twitter || !this.multiSearch) return;
        this.init();
    }
    init() {
        this.control();
    }
    control() {
        window.addEventListener('load', this.changeHeight.bind(this));
    }
    changeHeight() {
        this.twitter.style.minHeight = `${this.multiSearch.offsetHeight + 40}px`;
    }
}
